import { get } from 'lodash';
import React from 'react';
import { TreeNodeType } from '../../../../../../lib/types/types';
// import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import AbschlussAntrag from './content/Abschluss';
import Bescheid, { getFormStrucBescheid } from './content/Bescheid';
import ProjektDaten, { getFormStrucProjektDaten } from './content/ProjektDaten';
import PersonalKosten, { getFormStrucPersonalKosten } from './content/kosten/personal-kosten/PersonalKosten';
// import Sachkosten from './content/kosten/sach-kosten/Sachkosten';

// import Schemas
import AntragSchema from '../../../../../../lib/paths/antrag_FULL_Paths.json';
import Anlangen, { getFormStrucAnlangen } from './content/Anlagen';
import KontoDaten, { getFormStrucKontoDaten } from './content/KontoDaten';
import Ablehnungsbescheid from './content/Ablehnungsbescheid';
const P = AntragSchema.attributes;

export const TreeStructureAntrag = (application: any, printMode: boolean = false) => {
	let treeNodes: TreeNodeType[] = [
		{
			label: 'Projektdaten',
			content: <ProjektDaten />,
			formStruc: getFormStrucProjektDaten(),
		},
		{
			label: 'Kosten',
			// content: <ApplicationHeading title='Kosten' />,
			content: <PersonalKosten />,
			formStruc: getFormStrucPersonalKosten(application),
			// children: [
			// 	{
			// 		label: 'Personalkosten',
			// 	},
				// {
				// 	label: 'Sachkosten',
				// 	content: <Sachkosten />,
				// },
			// ],
		},
		{
			label: 'Anlagen',
			content: <Anlangen />,
			formStruc: getFormStrucAnlangen(),
		},
		{
			label: 'Kontodaten',
			content: <KontoDaten />,
			formStruc: getFormStrucKontoDaten(),
		},
		{
			label: 'Abschluss',
			content: <AbschlussAntrag />,
		},
	];

	if (get(application, `${P.Zuwendungsvertarg_Unterschriebener_Vertrag_VDMK.path}.id`) && !printMode) {
		treeNodes.push({
			label: 'Zuwendungsvertrag',
			content: <Bescheid />,
			formStruc: getFormStrucBescheid(),
		});
	}
	if (get(application, `${P.Status_Ablehnungsbescheid.path}.id`)) {
		treeNodes.push({
			label: 'Ablehnungsbescheid',
			content: <Ablehnungsbescheid />,
		});
	}
	return treeNodes;
};
